import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'

import { cn } from '@/utils/helpers'

import { Checkbox } from '../elements/checkbox'
import { Label } from '../elements/label'

/**
 *
 * @param {object} props
 * @param {Array<{id: string, label: string}>} props.options
 * @param {function} props.onChange
 * @param {string} props.id
 * @param {boolean} [props.large=false]
 */
function CheckboxGroup({ options, disabled, onChange, large = false, id, ...rest }) {
  // State is stored as a Set, but emitted as an array
  /**  @type {ReturnType<typeof useState<Set<string>>>} */
  const [value, setValue] = useState(new Set(rest.value || []))
  const update = (optionId, newVal) => {
    setValue((prev) => {
      const newSet = new Set(prev)
      if (newVal) newSet.add(optionId)
      else newSet.delete(optionId)
      return newSet
    })
  }
  useEffect(() => {
    onChange?.([...value])
  }, [value, onChange])

  return (
    <div className="flex flex-col gap-2">
      {options.map((option) => (
        <div className="flex items-center gap-3" key={option.id}>
          <Checkbox
            disabled={disabled}
            checked={value.has(option.id)}
            id={`${id}-${option.id}`}
            large={large}
            onCheckedChange={(newVal) => update(option.id, newVal)}
          />
          <Label className={cn(large ? 'text-2xl' : 'text-sm')} htmlFor={`${id}-${option.id}`}>
            {option.label}
          </Label>
        </div>
      ))}
    </div>
  )
}

export default CheckboxGroup

CheckboxGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onChange: PropTypes.func,
  id: PropTypes.string.isRequired,
  value: PropTypes.arrayOf(PropTypes.string),
  large: PropTypes.bool,
  disabled: PropTypes.bool,
}
